import axios from "./config";
import { getHeader } from "./media";

export const getAllTrainingVideos = async (
  page: number,
  size: number,
  params: { search?: string } = {}
): Promise<any> => {
  const query = new URLSearchParams({
    page: String(page),
    size: String(size),
  });
  if (params.search) {
    query.set("search", params.search);
  }

  const response = await axios.get<any>(
    `/admin/training-videos?${query.toString()}`,
    {
      headers: getHeader(),
    }
  );

  return response.data;
};

export const getTrainingVideoById = async (id: string | number): Promise<any> => {
  const response = await axios.get<any>(`/admin/training-videos/${id}`, {
    headers: getHeader(),
  });

  return response.data;
};

export const createTrainingVideo = async (
  formData: FormData
): Promise<any> => {
  const response = await axios.post<any>(
    `/admin/training-videos/create`,
    formData,
    {
      headers: getHeader(),
    }
  );

  return response.data;
};

export const updateTrainingVideo = async (
  id: string | number,
  formData: FormData
): Promise<any> => {
  const response = await axios.put<any>(
    `/admin/training-videos/${id}`,
    formData,
    {
      headers: getHeader(),
    }
  );

  return response.data;
};

export const deleteTrainingVideo = async (
  id: string | number
): Promise<any> => {
  const response = await axios.delete<any>(`/admin/training-videos/${id}`, {
    headers: getHeader(),
  });

  return response.data;
};
